import partitionArray from 'helpers/partitionArray'

import { useSiteStore } from 'js/lib/stores'

export default function useIsPublishRequestsEnabled() {
    const {
        site: {
            contentModerationEnabled,
            requireContentModerationFor,
            commentModerationEnabled,
            requireCommentModerationFor,
        },
    } = useSiteStore()

    const [
        requireContentModerationForExceptFiles,
        requireContentModerationForFiles,
    ] = partitionArray(requireContentModerationFor, (type) => type !== 'file')

    const isPublishRequestsContentEnabled =
        contentModerationEnabled &&
        requireContentModerationForExceptFiles?.length > 0

    const isPublishRequestsFilesEnabled =
        contentModerationEnabled && requireContentModerationForFiles?.length > 0

    const isPublishRequestsCommentsEnabled =
        commentModerationEnabled && requireCommentModerationFor?.length > 0

    return {
        isPublishRequestsAnyEnabled:
            isPublishRequestsContentEnabled ||
            isPublishRequestsFilesEnabled ||
            isPublishRequestsCommentsEnabled,
        isPublishRequestsContentEnabled,
        isPublishRequestsFilesEnabled,
        isPublishRequestsCommentsEnabled,
    }
}
